module.exports = __webpack_public_path__ + "img/aboutUsImg01.d931a21d.png";